import { useInterval } from "./useInterval";

const useChapterSlider = (chapters, chapterStep, dispatchChapterStep) => {
  const chapter = chapters?.[chapterStep];
  let delay = chapter?.duration;

  const nextChapter = () => {
    if (chapterStep + 1 >= chapters.length) {
      delay = null;
    } else {
      dispatchChapterStep(chapterStep + 1);
    }
  };

  const setChapter = (nextChapterStep) => {
    dispatchChapterStep(nextChapterStep);
  };

  useInterval(() => {
    nextChapter();
  }, delay);

  return { nextChapter, setChapter, chapter };
};

export default useChapterSlider;
